let rowIndex = 0

export const getRowIndex = () => {
  return rowIndex++
}